import { render } from "./SearchResult.vue?vue&type=template&id=13cc7276&scoped=true"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"

import "./SearchResult.vue?vue&type=style&index=0&id=13cc7276&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\LG\\Documents\\repositories\\opac\\search\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cc7276"]])

export default __exports__